import React, { useContext, useEffect, useMemo } from "react";
import { Context } from "../../index";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import PageHeader from "../../components/header/pageheader/PageHeader";
import UniversalTable from "../../components/organization/table/UniTable";
import PopupModule from "../../components/forms/popupModule";
import Modal from "../../components/forms/wrap/Modal";
import { getDeviceTypeConfig } from "../../components/forms/popupModule/deviceTypeConfig";
import "./styles.css";

export default observer(function AllModules() {
  const { store } = useContext(Context);
  const navigate = useNavigate();

  // Сортируем модули по ID и отбрасываем неактивированные (без charge_id)
  const itemsToDisplay = useMemo(() => {
    return [...store.modules]
      .filter((module) => module.charge_id)
      .sort((a, b) => a.id - b.id);
  }, [store.modules]);

  useEffect(() => {
    if (store.user.role === "root") {
      store.getAllModules();
    } else {
      store.getOrgModules();
    }
  }, []); // ← оставляем [], т.к. роль/компания не меняются в сессии

  const handlePlantClick = (id: number, moduleId: number) => {
    const curPlant = store.plants.find((el) => el.id === id);
    if (curPlant) {
      const curOrg = store.companies.find(
        (el) => el.id === curPlant.company_id,
      );
      store.setCompany(curOrg);
      store.setPlant(curPlant);
      navigate("/inplants");
    }
  };

  const handlePlantStay = (id: number, moduleId: number) => {
    console.log('handleplantstay')
    const curPlant = store.plants.find((el) => el.id === id);
    if (!curPlant) return;

    const curOrg = store.companies.find((el) => el.id === curPlant.company_id);
    store.setCompany(curOrg);

    const curModule = store.modules.find((el) => el.id === moduleId);
    store.setModule(curModule);

    // localStorage.setItem('curPlant', JSON.stringify(curPlant));
    store.setPlant(curPlant);
    store.getLines();

    const deviceConfig = getDeviceTypeConfig(curModule?.device_type);
    if (deviceConfig.tableMode === "stations") {
      store.getStations();
    }
  };

  const handleCloseModal = () => {
    store.setModule({});
  };

  return (
    <div className="all_module_container">
      <PageHeader title="Модули" />

      <UniversalTable
        data={itemsToDisplay}
        type="modules"
        setOrg={handlePlantClick}
        Edit={handlePlantStay}
      />

      <Modal isOpen={!!store.module?.id} onClose={handleCloseModal}>
        <PopupModule
          module={store.module}
          lines={store.lines}
          stations={store.stations}
          modules={store.modules}
          handleCloseModal={handleCloseModal}
          updateModule={(module, stations, childModules, modifiedKeys) => store.updateModule(module, stations, childModules, modifiedKeys)}
          updateChildModules={(parentModule, childModules, modifiedKeys) => store.updateChildModules(parentModule, childModules, modifiedKeys)}
          updateSmbModules={(module, stations, modifiedKeys) => store.updateSmbModules(module, stations, modifiedKeys)}
          deleteModule={(id) => store.deleteModule(id)}
          restartModule={(identifier) => store.restartModule(identifier)}
          fetchDeviceSecretStatus={(id) => store.fetchDeviceSecretStatus(id)}
          issueDeviceSecret={(id) => store.issueDeviceSecret(id)}
          revokeDeviceSecret={(id) => store.revokeDeviceSecret(id)}
          fetchApPassword={(id) => store.fetchApPassword(id)}
          rotateApPassword={(id) => store.rotateApPassword(id)}
          importApPassword={(id, apPassword) => store.importApPassword(id, apPassword)}
          refreshData={() => {
            if (store.user.role === "root") {
              store.getAllModules();
            } else {
              store.getOrgModules();
            }
          }}
        />
      </Modal>
    </div>
  );
});
